import { EventTypeEnum, PositionDiscardReason, TachographDriverStatus } from '../enums';

export interface IZoneEventMetadata {
    zoneExternalId: string;
}

export interface IEventTypeDto {
    id: number;
    code: EventTypeEnum;
    description: string;
}

export interface IEventMetadata {
    duration?: number;
    minSpeed?: number;
    maxSpeed?: number;
}

export interface ITachographEventMetadata {
    previousStatus: TachographDriverStatus;
    newStatus: TachographDriverStatus;
    startTime: string;
    endTime: string;
    cardId?: string;
}

/** CORRUPT_FRAME episode. The window goes in `startTime`/`endTime` and its length in `duration`. */
export interface ICorruptFrameEventMetadata {
    discardCount: number;
    reasons: Partial<Record<PositionDiscardReason, number>>;
}

export type TDeviceEventMetadata = Partial<IZoneEventMetadata> &
    Partial<IEventMetadata> &
    Partial<ITachographEventMetadata> &
    Partial<ICorruptFrameEventMetadata>;

export interface IDeviceEventDto {
    event: EventTypeEnum;
    deviceId: number;
    latitude: string;
    longitude: string;
    timestamp: string;
    value: string;
    metadata?: TDeviceEventMetadata;
}
